import { AfterViewInit, Component, Input } from '@angular/core';
import { SaleType, SoldPlate } from 'src/app/models/soldPlate';
import {SessionService} from "../../services/session-service";

declare var bootstrap: any;

@Component({
  selector: 'pla-sold-data-table',
  templateUrl: './sold-data-table.component.html',
  styleUrls: ['./sold-data-table.component.scss'],
})
export class SoldDataTableComponent implements AfterViewInit {
  @Input('data') public data: SoldPlate[] = [];

  constructor(private sessionService: SessionService) {}

  ngAfterViewInit(): void {
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }

  public tooltipPos(): string {
    if (window.innerWidth >= 850) {
      return 'left';
    }
    return 'top';
  }

  public visibleRecords(): SoldPlate[] {
    if (!this.data) return [];
    return this.data.filter(d => d.saleType != 4)
  }

  public saleTypeMapper(data: SoldPlate, saleType: SaleType): string {
    switch (saleType) {
      case SaleType.DVLA_AUTION:
        return 'DVLA Auction';

      case SaleType.DVLA:
        return 'DVLA';

      case SaleType.PLATEX:
        return 'Platex';

      case SaleType.THIRD_PARTY:
        if (data.seller !== null && data.seller !== '') data.seller = `${data.seller[0].toUpperCase()}${data.seller.slice(1)}`;
        if (window.location.href.indexOf('dev.') > -1) return `Sold / Withdrawn (${data.seller}) dev only`
        return 'Sold / Withdrawn';

      case SaleType.CURRENT_LISTING:
        return 'Added -';

      case SaleType.INITIAL_PRICE:
        return 'Added -';

      case SaleType.DVLA_AUCTION_IMPORT:
        return 'DVLA Auction';

      case SaleType.THIRD_PARTY_AUCTION_IMPORT:
        return data.seller;

      case SaleType.PRICE_CHANGE:
        return 'Price Change';

      case SaleType.CUSTOM:
        return data.seller;

      case SaleType.VERIFIED_AUCTION:
        return data.seller

      default:
        if (data.seller !== null && data.seller !== '') return data.seller;
        return 'Unknown';
    }
  }
}
